var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"exercise-img",style:({ backgroundImage: `url('${_vm.img}')` }),attrs:{"cols":_vm.cols,"md":_vm.colsMd},on:{"click":_vm.showVideoDialog}},[(_vm.video)?_c('watch-video-dialog',{ref:"watchVideo",attrs:{"thumb":_vm.img,"video":_vm.video,"is-second-dialog":_vm.isSecondDialog}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }